/** PURE_IMPORTS_START _observable_zip PURE_IMPORTS_END */
import { ZipOperator } from '../observable/zip';
export function zipAll(project) {
    return function (source) { return source.lift(new ZipOperator(project)); };
}
//# sourceMappingURL=zipAll.js.map
